/*
 * @Author: shfang
 * @Date: 2024-09-26 14:03:40
 * @LastEditors: shfang
 * @LastEditTime: 2025-10-22 17:12:50
 * @Description: file content
 * @FilePath: \jxjy-base-web\src\main.js
 */
require("promise.prototype.finally").shim();
import Vue from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "./store";
import microApp from "@micro-zoe/micro-app";
import ElementUI from "element-ui";
import { VueCropper } from "vue-cropper";
import "@/common/js/theme.js";
import directives from "@/common/js/directives.js";
import filters from "@/common/js/filters.js";
import toolTip from "@/components/toolTip/toolTip.vue";
// setInterval(function () {
//   check();
// }, 4000);
// var check = function () {
//   function doCheck(a) {
//     if (("" + a / a)["length"] !== 1 || a % 20 === 0) {
//       (function () {})["constructor"]("debugger")();
//     } else {
//       (function () {})["constructor"]("debugger")();
//     }
//     doCheck(++a);
//   }
//   try {
//     doCheck(0);
//   } catch (err) {}
// };
// check();

// 挂载到 Vue 原型，供所有组件使用
Vue.use(toolTip);
Vue.use(directives);
Vue.use(filters);
Vue.prototype.$microApp = microApp;
Vue.prototype.$http = axios;
microApp.start({
  "disable-memory-router": true, // 关闭虚拟路由系统
  "disable-patch-request": true, // 关闭对子应用请求的拦截
});
Vue.use(ElementUI);
Vue.use(VueCropper);
Vue.config.productionTip = false;
let user = JSON.parse(localStorage.getItem("user"));
microApp.setGlobalData({
  theme: user?.themeColor || localStorage.getItem("--primary"),
});
router.beforeEach((to, from, next) => {
  next();
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
import axios from "@/http/axios.js";
